<script>
  export let hour;
  export let minute;
  export let second;
  export let progress;
  export let stop;
  import { onMount } from 'svelte';

  let scale = 1;
  const resize = () => {
    const innerWidth = window.innerWidth;
    scale = (innerWidth > 600 ? 600 : innerWidth) / 160;
  };

  onMount(async () => {
    resize();
	});
</script>

<svelte:window on:resize={resize} />
<div>
  <div class="wrapper" style="z-index:2;">
    <p class="text">{second !== -1 ? `${hour}:${minute}:${second}` : ""}</p>
  </div>
  <div class="wrapper" style="z-index:1;">
    <div class="item" style="{`transform:scale(${scale},${scale})`}">
      <svg width="160" height="160" xmlns="http://www.w3.org/2000/svg">
        <g>
          <circle id="circle" class="timer-circle" style="{`stroke-dashoffset:${360 - (progress * 251) }`}" r="40" cy="81" cx="81" stroke-width="8" stroke="#6fdb6f" fill="none"/>
        </g>
      </svg>
    </div>
  </div>
  <div class="wrapper" style="z-index:3;">
    <button class="waves-effect waves-light btn red lighten-1 stop" on:click="{stop}">やめる</button>
  </div>
</div>

<style>
.text {
  font-size:13vw;
}
@media screen and (min-width:1024px) {
  .text {
    font-size:128px;
  }
}

.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width:100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

/*  タイマーの表示場所指定   */
.item {
  position: relative;
  float: left;
  top: 2vh;
}

/*  真上から円を描く指定   */
svg {
   -webkit-transform: rotate(-90deg);
    transform: rotate(-90deg);
}

/*  円を描く動画の準備   */
.timer-circle {
  stroke-dasharray: 360;
  stroke-dashoffset: 360;
  transition: all 0.5s linear;
}

.btn.stop {
  position: relative;
  top: 22vh;
}
</style>